'use strict';

var _a, _b, _c, _d, _e;

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.INPUT_PADDING_CIRCULAR =
  exports.INPUT_PADDING_ROUNDED =
  exports.INPUT_PADDING_GEOMETRIC =
  exports.LINE_HEIGHT =
  exports.ICON_SIZE =
    void 0;

var components_1 = require('../../../constants/components');

exports.ICON_SIZE =
  ((_a = {}),
  (_a[components_1.INPUT_SIZES.xsmall] = 16),
  (_a[components_1.INPUT_SIZES.small] = 20),
  (_a[components_1.INPUT_SIZES.medium] = 24),
  _a);
exports.LINE_HEIGHT =
  ((_b = {}),
  (_b[components_1.INPUT_SIZES.xsmall] = 24),
  (_b[components_1.INPUT_SIZES.small] = 32),
  (_b[components_1.INPUT_SIZES.medium] = 48),
  _b);
exports.INPUT_PADDING_GEOMETRIC =
  ((_c = {}),
  (_c[components_1.INPUT_SIZES.xsmall] = {
    default: 0,
    withIcon: 0,
    icon: 4,
    topWithLabel: 0,
    bottomWidthLabel: 0,
    borderRadius: 0,
  }),
  (_c[components_1.INPUT_SIZES.small] = {
    default: 0,
    withIcon: 0,
    icon: 8,
    topWithLabel: 0,
    bottomWidthLabel: 0,
  }),
  (_c[components_1.INPUT_SIZES.medium] = {
    default: 0,
    withIcon: 0,
    icon: 8,
    topWithLabel: 20,
    bottomWidthLabel: 4,
  }),
  _c);
exports.INPUT_PADDING_ROUNDED =
  ((_d = {}),
  (_d[components_1.INPUT_SIZES.xsmall] = {
    default: 8,
    withIcon: 8,
    icon: 4,
    top: 4,
    bottom: 4,
    topWithLabel: 4,
    bottomWidthLabel: 4,
    borderRadius: 4,
  }),
  (_d[components_1.INPUT_SIZES.small] = {
    default: 12,
    withIcon: 8,
    icon: 8,
    top: 6,
    bottom: 6,
    topWithLabel: 6,
    bottomWidthLabel: 6,
    borderRadius: 8,
  }),
  (_d[components_1.INPUT_SIZES.medium] = {
    default: 12,
    withIcon: 8,
    icon: 8,
    top: 0,
    bottom: 0,
    topWithLabel: 20,
    bottomWidthLabel: 4,
    borderRadius: 8,
  }),
  _d);
exports.INPUT_PADDING_CIRCULAR =
  ((_e = {}),
  (_e[components_1.INPUT_SIZES.xsmall] = {
    default: 12,
    withIcon: 10,
    icon: 4,
    top: 4,
    bottom: 4,
    topWithLabel: 4,
    bottomWidthLabel: 4,
    borderRadius: 12,
  }),
  (_e[components_1.INPUT_SIZES.small] = {
    default: 14,
    withIcon: 10,
    icon: 8,
    top: 6,
    bottom: 6,
    topWithLabel: 6,
    bottomWidthLabel: 6,
    borderRadius: 24,
  }),
  (_e[components_1.INPUT_SIZES.medium] = {
    default: 20,
    withIcon: 16,
    icon: 8,
    top: 0,
    bottom: 0,
    topWithLabel: 20,
    bottomWidthLabel: 4,
    borderRadius: 24,
  }),
  _e);
